var parseVersion = (str) => {
	// see webpack/lib/util/semver.js for original code
	var p=p=>{return p.split(".").map((p=>{return+p==p?+p:p}))},n=/^([^-+]+)?(?:-([^+]+))?(?:\+(.+))?$/.exec(str),r=n[1]?p(n[1]):[];return n[2]&&(r.length++,r.push.apply(r,p(n[2]))),n[3]&&(r.push([]),r.push.apply(r,p(n[3]))),r;
}
var versionLt = (a, b) => {
	// see webpack/lib/util/semver.js for original code
	a=parseVersion(a),b=parseVersion(b);for(var r=0;;){if(r>=a.length)return r<b.length&&"u"!=(typeof b[r])[0];var e=a[r],n=(typeof e)[0];if(r>=b.length)return"u"==n;var t=b[r],f=(typeof t)[0];if(n!=f)return"o"==n&&"n"==f||("s"==f||"u"==n);if("o"!=n&&"u"!=n&&e!=t)return e<t;r++}
}
var rangeToString = (range) => {
	// see webpack/lib/util/semver.js for original code
	var r=range[0],n="";if(1===range.length)return"*";if(r+.5){n+=0==r?">=":-1==r?"<":1==r?"^":2==r?"~":r>0?"=":"!=";for(var e=1,a=1;a<range.length;a++){e--,n+="u"==(typeof(t=range[a]))[0]?"-":(e>0?".":"")+(e=2,t)}return n}var g=[];for(a=1;a<range.length;a++){var t=range[a];g.push(0===t?"not("+o()+")":1===t?"("+o()+" || "+o()+")":2===t?g.pop()+" "+g.pop():rangeToString(t))}return o();function o(){return g.pop().replace(/^\((.+)\)$/,"$1")}
}
var satisfy = (range, version) => {
	// see webpack/lib/util/semver.js for original code
	if(0 in range){version=parseVersion(version);var e=range[0],r=e<0;r&&(e=-e-1);for(var n=0,i=1,a=!0;;i++,n++){var f,s,g=i<range.length?(typeof range[i])[0]:"";if(n>=version.length||"o"==(s=(typeof(f=version[n]))[0]))return!a||("u"==g?i>e&&!r:""==g!=r);if("u"==s){if(!a||"u"!=g)return!1}else if(a)if(g==s)if(i<=e){if(f!=range[i])return!1}else{if(r?f>range[i]:f<range[i])return!1;f!=range[i]&&(a=!1)}else if("s"!=g&&"n"!=g){if(r||i<=e)return!1;a=!1,i--}else{if(i<=e||s<g!=r)return!1;a=!1}else"s"!=g&&"n"!=g&&(a=!1,i--)}}var t=[],o=t.pop.bind(t);for(n=1;n<range.length;n++){var u=range[n];t.push(1==u?o()|o():2==u?o()&o():u?satisfy(u,version):!o())}return!!o();
}
var ensureExistence = (scopeName, key) => {
	var scope = __webpack_require__.S[scopeName];
	if(!scope || !__webpack_require__.o(scope, key)) throw new Error("Shared module " + key + " doesn't exist in shared scope " + scopeName);
	return scope;
};
var findVersion = (scope, key) => {
	var versions = scope[key];
	var key = Object.keys(versions).reduce((a, b) => {
		return !a || versionLt(a, b) ? b : a;
	}, 0);
	return key && versions[key]
};
var findSingletonVersionKey = (scope, key) => {
	var versions = scope[key];
	return Object.keys(versions).reduce((a, b) => {
		return !a || (!versions[a].loaded && versionLt(a, b)) ? b : a;
	}, 0);
};
var getInvalidSingletonVersionMessage = (scope, key, version, requiredVersion) => {
	return "Unsatisfied version " + version + " from " + (version && scope[key][version].from) + " of shared singleton module " + key + " (required " + rangeToString(requiredVersion) + ")"
};
var getSingleton = (scope, scopeName, key, requiredVersion) => {
	var version = findSingletonVersionKey(scope, key);
	return get(scope[key][version]);
};
var getSingletonVersion = (scope, scopeName, key, requiredVersion) => {
	var version = findSingletonVersionKey(scope, key);
	if (!satisfy(requiredVersion, version)) warn(getInvalidSingletonVersionMessage(scope, key, version, requiredVersion));
	return get(scope[key][version]);
};
var getStrictSingletonVersion = (scope, scopeName, key, requiredVersion) => {
	var version = findSingletonVersionKey(scope, key);
	if (!satisfy(requiredVersion, version)) throw new Error(getInvalidSingletonVersionMessage(scope, key, version, requiredVersion));
	return get(scope[key][version]);
};
var findValidVersion = (scope, key, requiredVersion) => {
	var versions = scope[key];
	var key = Object.keys(versions).reduce((a, b) => {
		if (!satisfy(requiredVersion, b)) return a;
		return !a || versionLt(a, b) ? b : a;
	}, 0);
	return key && versions[key]
};
var getInvalidVersionMessage = (scope, scopeName, key, requiredVersion) => {
	var versions = scope[key];
	return "No satisfying version (" + rangeToString(requiredVersion) + ") of shared module " + key + " found in shared scope " + scopeName + ".\n" +
		"Available versions: " + Object.keys(versions).map((key) => {
		return key + " from " + versions[key].from;
	}).join(", ");
};
var getValidVersion = (scope, scopeName, key, requiredVersion) => {
	var entry = findValidVersion(scope, key, requiredVersion);
	if(entry) return get(entry);
	throw new Error(getInvalidVersionMessage(scope, scopeName, key, requiredVersion));
};
var warn = (msg) => {
	if (typeof console !== "undefined" && console.warn) console.warn(msg);
};
var warnInvalidVersion = (scope, scopeName, key, requiredVersion) => {
	warn(getInvalidVersionMessage(scope, scopeName, key, requiredVersion));
};
var get = (entry) => {
	entry.loaded = 1;
	return entry.get()
};
var init = (fn) => (function(scopeName, a, b, c) {
	var promise = __webpack_require__.I(scopeName);
	if (promise && promise.then) return promise.then(fn.bind(fn, scopeName, __webpack_require__.S[scopeName], a, b, c));
	return fn(scopeName, __webpack_require__.S[scopeName], a, b, c);
});

var load = /*#__PURE__*/ init((scopeName, scope, key) => {
	ensureExistence(scopeName, key);
	return get(findVersion(scope, key));
});
var loadFallback = /*#__PURE__*/ init((scopeName, scope, key, fallback) => {
	return scope && __webpack_require__.o(scope, key) ? get(findVersion(scope, key)) : fallback();
});
var loadVersionCheck = /*#__PURE__*/ init((scopeName, scope, key, version) => {
	ensureExistence(scopeName, key);
	return get(findValidVersion(scope, key, version) || warnInvalidVersion(scope, scopeName, key, version) || findVersion(scope, key));
});
var loadSingleton = /*#__PURE__*/ init((scopeName, scope, key) => {
	ensureExistence(scopeName, key);
	return getSingleton(scope, scopeName, key);
});
var loadSingletonVersionCheck = /*#__PURE__*/ init((scopeName, scope, key, version) => {
	ensureExistence(scopeName, key);
	return getSingletonVersion(scope, scopeName, key, version);
});
var loadStrictVersionCheck = /*#__PURE__*/ init((scopeName, scope, key, version) => {
	ensureExistence(scopeName, key);
	return getValidVersion(scope, scopeName, key, version);
});
var loadStrictSingletonVersionCheck = /*#__PURE__*/ init((scopeName, scope, key, version) => {
	ensureExistence(scopeName, key);
	return getStrictSingletonVersion(scope, scopeName, key, version);
});
var loadVersionCheckFallback = /*#__PURE__*/ init((scopeName, scope, key, version, fallback) => {
	if(!scope || !__webpack_require__.o(scope, key)) return fallback();
	return get(findValidVersion(scope, key, version) || warnInvalidVersion(scope, scopeName, key, version) || findVersion(scope, key));
});
var loadSingletonFallback = /*#__PURE__*/ init((scopeName, scope, key, fallback) => {
	if(!scope || !__webpack_require__.o(scope, key)) return fallback();
	return getSingleton(scope, scopeName, key);
});
var loadSingletonVersionCheckFallback = /*#__PURE__*/ init((scopeName, scope, key, version, fallback) => {
	if(!scope || !__webpack_require__.o(scope, key)) return fallback();
	return getSingletonVersion(scope, scopeName, key, version);
});
var loadStrictVersionCheckFallback = /*#__PURE__*/ init((scopeName, scope, key, version, fallback) => {
	var entry = scope && __webpack_require__.o(scope, key) && findValidVersion(scope, key, version);
	return entry ? get(entry) : fallback();
});
var loadStrictSingletonVersionCheckFallback = /*#__PURE__*/ init((scopeName, scope, key, version, fallback) => {
	if(!scope || !__webpack_require__.o(scope, key)) return fallback();
	return getStrictSingletonVersion(scope, scopeName, key, version);
});
var installedModules = {};
var moduleToHandlerMapping = {
	62045: () => (loadStrictSingletonVersionCheckFallback("default", "@angular/core", [1,17,3,11], () => (__webpack_require__.e(7580).then(() => (() => (__webpack_require__(/*! @angular/core */ 37580))))))),
	69203: () => (loadStrictSingletonVersionCheckFallback("default", "@angular/common", [1,17,3,11], () => (__webpack_require__.e(316).then(() => (() => (__webpack_require__(/*! @angular/common */ 60316))))))),
	32778: () => (loadStrictSingletonVersionCheckFallback("default", "rxjs/operators", [2,7,8,0], () => (__webpack_require__.e(8219).then(() => (() => (__webpack_require__(/*! rxjs/operators */ 98219))))))),
	44866: () => (loadStrictSingletonVersionCheckFallback("default", "rxjs", [2,7,8,0], () => (__webpack_require__.e(845).then(() => (() => (__webpack_require__(/*! rxjs */ 80845))))))),
	51599: () => (loadStrictSingletonVersionCheckFallback("default", "@angular/core/primitives/signals", [1,17,3,11], () => (__webpack_require__.e(5689).then(() => (() => (__webpack_require__(/*! @angular/core/primitives/signals */ 85689))))))),
	91667: () => (loadStrictSingletonVersionCheckFallback("default", "@angular/common/http", [1,17,3,11], () => (__webpack_require__.e(8824).then(() => (() => (__webpack_require__(/*! @angular/common/http */ 46443))))))),
	44870: () => (loadStrictSingletonVersionCheckFallback("default", "@angular/platform-browser", [1,17,3,11], () => (__webpack_require__.e(8055).then(() => (() => (__webpack_require__(/*! @angular/platform-browser */ 80436))))))),
	91448: () => (loadStrictSingletonVersionCheckFallback("default", "aws-amplify", [1,6,0,17], () => (__webpack_require__.e(3677).then(() => (() => (__webpack_require__(/*! aws-amplify */ 36058))))))),
	30062: () => (loadStrictSingletonVersionCheckFallback("default", "ngx-bootstrap/collapse", [1,12,0,0], () => (__webpack_require__.e(8751).then(() => (() => (__webpack_require__(/*! ngx-bootstrap/collapse */ 18751))))))),
	9074: () => (loadStrictSingletonVersionCheckFallback("default", "ngx-bootstrap/utils", [1,12,0,0], () => (__webpack_require__.e(4722).then(() => (() => (__webpack_require__(/*! ngx-bootstrap/utils */ 72341))))))),
	42873: () => (loadStrictSingletonVersionCheckFallback("default", "@angular/animations", [1,17,3,11], () => (__webpack_require__.e(4791).then(() => (() => (__webpack_require__(/*! @angular/animations */ 47172))))))),
	13154: () => (loadStrictSingletonVersionCheckFallback("default", "ngx-bootstrap/positioning", [1,12,0,0], () => (__webpack_require__.e(3282).then(() => (() => (__webpack_require__(/*! ngx-bootstrap/positioning */ 40901))))))),
	7423: () => (loadStrictSingletonVersionCheckFallback("default", "ngx-bootstrap/focus-trap", [1,12,0,0], () => (__webpack_require__.e(3928).then(() => (() => (__webpack_require__(/*! ngx-bootstrap/focus-trap */ 51547))))))),
	33967: () => (loadStrictSingletonVersionCheckFallback("default", "ngx-bootstrap/component-loader", [1,12,0,0], () => (__webpack_require__.e(3136).then(() => (() => (__webpack_require__(/*! ngx-bootstrap/component-loader */ 70755))))))),
	3041: () => (loadStrictSingletonVersionCheckFallback("default", "@angular/forms", [1,17,3,11], () => (__webpack_require__.e(2075).then(() => (() => (__webpack_require__(/*! @angular/forms */ 34456))))))),
	79383: () => (loadStrictSingletonVersionCheckFallback("default", "@angular/router", [1,17,3,11], () => (__webpack_require__.e(5072).then(() => (() => (__webpack_require__(/*! @angular/router */ 95072))))))),
	33325: () => (loadStrictSingletonVersionCheckFallback("default", "@n5x-tech/platform-cnpj-validator", [3,0,0,2,,"beta",7], () => (__webpack_require__.e(3051).then(() => (() => (__webpack_require__(/*! @n5x-tech/platform-cnpj-validator */ 3051))))))),
	60794: () => (loadStrictSingletonVersionCheckFallback("default", "ngx-bootstrap/modal", [1,12,0,0], () => (__webpack_require__.e(2457).then(() => (() => (__webpack_require__(/*! ngx-bootstrap/modal */ 2457))))))),
	37941: () => (loadStrictSingletonVersionCheckFallback("default", "ngx-mask", [1,17,0,4], () => (__webpack_require__.e(6769).then(() => (() => (__webpack_require__(/*! ngx-mask */ 86769))))))),
	20101: () => (loadStrictSingletonVersionCheckFallback("default", "ngx-bootstrap/alert", [1,12,0,0], () => (__webpack_require__.e(5063).then(() => (() => (__webpack_require__(/*! ngx-bootstrap/alert */ 95063))))))),
	10818: () => (loadStrictSingletonVersionCheckFallback("default", "angular-svg-icon", [1,17,0,0], () => (__webpack_require__.e(3313).then(() => (() => (__webpack_require__(/*! angular-svg-icon */ 3313))))))),
	76309: () => (loadStrictSingletonVersionCheckFallback("default", "jwt-decode", [1,4,0,0], () => (__webpack_require__.e(4751).then(() => (() => (__webpack_require__(/*! jwt-decode */ 34751))))))),
	9906: () => (loadStrictSingletonVersionCheckFallback("default", "ngx-bootstrap/typeahead", [1,12,0,0], () => (__webpack_require__.e(5337).then(() => (() => (__webpack_require__(/*! ngx-bootstrap/typeahead */ 35337))))))),
	4196: () => (loadStrictSingletonVersionCheckFallback("default", "ngx-bootstrap/tooltip", [1,12,0,0], () => (__webpack_require__.e(6465).then(() => (() => (__webpack_require__(/*! ngx-bootstrap/tooltip */ 36465))))))),
	21412: () => (loadStrictSingletonVersionCheckFallback("default", "ngx-currency", [1,17,0,0], () => (__webpack_require__.e(7453).then(() => (() => (__webpack_require__(/*! ngx-currency */ 7453))))))),
	66241: () => (loadStrictSingletonVersionCheckFallback("default", "@aws-amplify/ui-angular", [1,5,0,10], () => (__webpack_require__.e(8289).then(() => (() => (__webpack_require__(/*! @aws-amplify/ui-angular */ 38289))))))),
	72633: () => (loadStrictSingletonVersionCheckFallback("default", "ngx-bootstrap/accordion", [1,12,0,0], () => (__webpack_require__.e(9803).then(() => (() => (__webpack_require__(/*! ngx-bootstrap/accordion */ 39803)))))))
};
// no consumes in initial chunks
var chunkMapping = {
	"436": [
		62045,
		69203,
		91667
	],
	"670": [
		44866,
		62045,
		69203,
		91448
	],
	"755": [
		9074,
		13154,
		62045,
		69203
	],
	"901": [
		9074,
		44866,
		62045,
		69203
	],
	"1132": [
		42873,
		62045
	],
	"1547": [
		32778,
		62045,
		69203
	],
	"2075": [
		32778,
		44866,
		69203
	],
	"2184": [
		30062,
		62045,
		69203
	],
	"2341": [
		62045
	],
	"2457": [
		7423,
		9074,
		13154,
		33967
	],
	"2691": [
		32778,
		44866,
		44870,
		62045,
		69203
	],
	"3136": [
		69203
	],
	"3282": [
		44866,
		69203
	],
	"3313": [
		32778
	],
	"3928": [
		32778,
		69203
	],
	"4456": [
		32778,
		44866,
		62045,
		69203
	],
	"4791": [
		69203
	],
	"4838": [
		7423,
		9074,
		13154,
		33967,
		62045
	],
	"5020": [
		44870,
		79383,
		62045,
		91448,
		42873,
		69203,
		3041,
		33325,
		60794,
		91667,
		37941,
		20101,
		10818,
		44866,
		76309,
		9906,
		4196,
		21412,
		66241,
		72633
	],
	"5063": [
		9074
	],
	"5072": [
		32778
	],
	"5337": [
		9074,
		13154,
		32778,
		33967
	],
	"5694": [
		32778,
		44866,
		62045,
		69203,
		91667
	],
	"6443": [
		32778,
		44866,
		62045,
		69203
	],
	"6465": [
		9074,
		13154,
		33967
	],
	"7172": [
		62045,
		69203
	],
	"7444": [
		9074,
		62045,
		69203
	],
	"7580": [
		32778,
		44866,
		51599
	],
	"7718": [
		3041,
		9074,
		13154,
		32778,
		33967,
		42873,
		44866,
		62045,
		69203
	],
	"7935": [
		62045
	],
	"8055": [
		91667
	],
	"8751": [
		42873
	],
	"8824": [
		32778,
		44866
	],
	"8846": [
		9074,
		13154,
		33967,
		44866,
		62045,
		69203
	],
	"9150": [
		3041,
		62045,
		69203
	],
	"9803": [
		30062
	],
	"9834": [
		3041,
		62045
	]
};
var startedInstallModules = {};
__webpack_require__.f.consumes = (chunkId, promises) => {
	if(__webpack_require__.o(chunkMapping, chunkId)) {
		chunkMapping[chunkId].forEach((id) => {
			if(__webpack_require__.o(installedModules, id)) return promises.push(installedModules[id]);
			if(!startedInstallModules[id]) {
			var onFactory = (factory) => {
				installedModules[id] = 0;
				__webpack_require__.m[id] = (module) => {
					delete __webpack_require__.c[id];
					module.exports = factory();
				}
			};
			startedInstallModules[id] = true;
			var onError = (error) => {
				delete installedModules[id];
				__webpack_require__.m[id] = (module) => {
					delete __webpack_require__.c[id];
					throw error;
				}
			};
			try {
				var promise = moduleToHandlerMapping[id]();
				if(promise.then) {
					promises.push(installedModules[id] = promise.then(onFactory)['catch'](onError));
				} else onFactory(promise);
			} catch(e) { onError(e); }
			}
		});
	}
}